var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIahIllustrationShopAndDine = function SvgIahIllustrationShopAndDine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 301,
    fill: "none",
    viewBox: "0 0 500 301"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DDEEF8",
    d: "M350.016 89.531a74 74 0 0 0-2.312-3.663c-10.715-15.926-29.162-26.817-47.309-31.745a107 107 0 0 0-24.376-3.566c-53.945-1.827-75.408 40.787-93.231 51.785s-45.247 29.78-43.42 69.185 30.166 76.502 85.009 78.821c54.842 2.318 58.5-22.459 89.119-31.63 20.265-6.065 34.661-26.549 41.714-45.48 9.605-25.792 9.152-59.305-5.194-83.707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#75787B",
    d: "M135.554 107.47h-3.076V247.5h3.076zM365.943 107.47h-3.356V247.5h3.356z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#76818C",
    d: "M158.201 87.067h-3.355v138.352h3.355zM343.854 87.067h-3.355v138.352h3.355z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.792 102.919h-11.5L153.435 67.5h9.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M152.285 102.919h-11.494L162.634 67.5h9.194z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163.785 102.919h-11.5L171.829 67.5h9.199z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M175.279 102.919h-11.494L181.028 67.5h9.194z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M186.778 102.919h-11.5L190.222 67.5h9.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M198.272 102.919h-11.494L199.422 67.5h9.199z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.771 102.919h-11.499L208.621 67.5h9.194z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M221.265 102.919h-11.494l8.044-35.419h9.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.764 102.919h-11.499l5.749-35.419h9.194z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M244.258 102.919h-11.494l3.445-35.419h9.199z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.752 102.919h-11.494l1.15-35.419h9.194z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M267.251 102.919h-11.499l-1.15-35.419h9.199z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278.745 102.919h-11.494l-3.45-35.419h9.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M290.244 102.919h-11.499L273.001 67.5h9.194z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M301.739 102.919h-11.494l-8.05-35.419h9.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M313.238 102.919h-11.499L291.395 67.5h9.194z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M324.732 102.919h-11.494L300.589 67.5h9.199z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M336.231 102.919h-11.499L309.788 67.5h9.194z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M347.725 102.919h-11.494L318.982 67.5h9.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M359.224 102.919h-11.499L328.182 67.5h9.199z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370.718 102.919h-11.494L337.381 67.5h9.194z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M129.292 102.951h11.499v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.831a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M140.792 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.826a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M152.285 102.951h11.5v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.831a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M163.785 102.951h11.483v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M175.267 102.951h11.494v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.815a4.34 4.34 0 0 1-4.34-4.338z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M186.778 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.826a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M198.272 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M209.771 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M221.265 102.951h11.499v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.842a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M232.764 102.951h11.494v12.211a4.338 4.338 0 0 1-4.339 4.338h-2.815a4.34 4.34 0 0 1-4.34-4.338z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M244.258 102.951h11.494v12.211a4.338 4.338 0 0 1-4.339 4.338h-2.843a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M255.752 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M267.251 102.951h11.494v12.211a4.338 4.338 0 0 1-4.339 4.338h-2.842a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M278.745 102.951h11.516v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M290.261 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M301.739 102.951h11.493v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.842a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M313.238 102.951h11.493v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.842a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M324.732 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M336.231 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.336 4.336 0 0 1-4.339-4.338v-12.211z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#71B6E2",
    d: "M347.725 102.951h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M359.224 102.951h11.494v12.211a4.336 4.336 0 0 1-4.339 4.338h-2.842a4.34 4.34 0 0 1-4.34-4.338v-12.211z"
  })));
};
export default SvgIahIllustrationShopAndDine;